import React from "react";
import "./SideBar.scss";
import { Link } from "react-router-dom";

function SideBar({ listCategory, listBrand, listCateMapBrand }) {
  const getBrandIdsForCategory = (categoryId, listCateMapBrand) => {
    if (!listCateMapBrand || listCateMapBrand.length === 0) {
      return [];
    }
    const categoryMap = listCateMapBrand.find((item) => item.categoryId === categoryId);
    if (categoryMap) {
      return categoryMap.brandIds;
    }

    return [];
  };

  return (
    <div className="sidebar-menu">
      <ul className="big-lists">
        {listCategory &&
          listCategory.length !== 0 &&
          listCategory.map((cate) => {
            return (
              <li key={cate._id}>
                <Link to={`/category/${cate.cateSlug}`}>
                  {cate.cateName}
                  <i className="bi bi-chevron-right"></i>
                </Link>
                <ul className="small-lists">
                  {getBrandIdsForCategory(cate._id, listCateMapBrand).map((brandId) => {
                    const brand = listBrand.find((brand) => brand._id === brandId);
                    if (brand) {
                      return (
                        <li key={brandId}>
                          <Link to={`/category/${cate.cateSlug}&brand=${brand.brandSlug}`}>
                            <img
                              className="logo_brand_img mr-2"
                              src={brand.image}
                              alt={brand.brandName}
                            />
                            {brand.brandName}
                          </Link>
                        </li>
                      );
                    }
                    return "";
                  })}
                </ul>
              </li>
            );
          })}
      </ul>
    </div>
  );
}

export default SideBar;
